import Api from '@/api/Api'

export default {
  loginUser (params) {
    return Api().post('Authentication/login_user', params)
  },

  logoutTracker (params) {
    return Api().post('Authentication/logout_tracker', params)
  },

  updateSessionData (params) {
    return Api().post('Authentication/update_session_data', params)
  },

  ResetPassword (params) {
    return Api().post('Authentication/reset_password', params)
  },

  resendEmailConfirmation (params) {
    return Api().post('Authentication/resend_email', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/AuthenticationAPI.js